import { render, staticRenderFns } from "./paymentez.vue?vue&type=template&id=c28dd7b2&scoped=true&"
import script from "./paymentez.vue?vue&type=script&lang=js&"
export * from "./paymentez.vue?vue&type=script&lang=js&"
import style0 from "./paymentez.vue?vue&type=style&index=0&id=c28dd7b2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28dd7b2",
  null
  
)

export default component.exports